import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import Avatar from '@mui/material/Avatar';
import { Button, TextField } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import swal from "sweetalert";
import Swal from 'sweetalert2';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import EmsNavbar from "../../frontend/EmsNavbar";
import { useMediaQuery, useTheme } from '@mui/material';
import WorkshopNavbar from "../../frontend/WorkShop/WorkshopNavbar/WorkshopNavbar";
import ConferenceNavbar from "../../frontend/Conference/ConferenceNavbar";
import NewVersionAbstractFooter from "../AbstractAuth/NewVersion/NewVersionAnstractFooter";
import { useDeadline } from "../../contexts/DeadlineContext";
const ConferencePartiticpantVerirication = () => {
    const { offButton, abstractHomeSetup, getAbstractDeadLineStatus } = useDeadline();
    const history = useHistory();
    const eventid = localStorage.getItem('eventid');
    const storedData = localStorage.getItem(`homeSetupData-${eventid}`);
    const [reload, setReload] = useState(false);
    const [badgeDataUrl, setBadgeDataUrl] = useState([]);
    const [loaded, setLoaded] = useState(false);
    // This effect will run once on mount and trigger a reload after 2 seconds
    useEffect(() => {
        const timer = setTimeout(() => {
            setReload(true); // Trigger reload after 2 seconds
        }, 2000);
        // Clean up the timer
        return () => clearTimeout(timer);
    }, []);
    // Effect to handle the reload state change (this will trigger a re-render)
    useEffect(() => {
        if (reload) {
            // You can reset the reload state to false to avoid it from repeating again
            setReload(false);
        }
    }, [reload]);

    const [emailexist, setemailexist] = useState({
        email: "",
        error_list: [],
    });


    const [isButtonDisabled, setIsButtonDisabled] = useState(true);

    useEffect(() => {
        // Disable the button initially if the email is not valid or empty
        setIsButtonDisabled(Boolean(emailexist.error_list.email) || emailexist.email === "");
    }, [emailexist.error_list.email, emailexist.email]);

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const gradientBackground = '#05597D';



    //const [hasReloaded, setHasReloaded] = useState(false); // Track if reload has occurred

    // useEffect(() => {
    //     // Check if the page has been loaded before using localStorage
    //     if (!localStorage.getItem("hasReloaded")) {
    //         // Set a timeout to reload after 2 seconds
    //         const timer = setTimeout(() => {
    //             localStorage.setItem("hasReloaded", "true"); // Mark that the reload has happened
    //             window.location.reload(); // Reload the page
    //         }, 5000); // Wait for 2 seconds before reloading

    //         return () => clearTimeout(timer); // Cleanup the timer if the component is unmounted
    //     }
    // }, []);


    const handleInput = (e) => {
        e.persist();
        const { name, value } = e.target;
        setemailexist({ ...emailexist, [name]: value });

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (name === 'email' && value) {
            if (!emailRegex.test(value)) {
                setemailexist(prevState => ({
                    ...prevState,
                    error_list: { ...prevState.error_list, email: 'Please enter a valid email address' }
                }));
            } else {
                setemailexist(prevState => ({
                    ...prevState,
                    error_list: { ...prevState.error_list, email: '' }
                }));
                setIsButtonDisabled(false);
            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const data = {
            email: emailexist.email,
            eventid,
        };

        if (emailexist.email !== "") {
            localStorage.setItem('conference_particpant_email', emailexist.email);
        }

        axios.get('/sanctum/csrf-cookie').then(response => {
            axios.post(`api/conference-participant-email`, data).then(res => {
                if (res.data.redirect === 0) {
                    const searchingEmain = res.data.checkEmail;
                    const id = searchingEmain.id;
                    const hasAlreadyVerified = Array.isArray(searchingEmain.cppyament) &&
                        searchingEmain.cppyament.length > 0 &&
                        searchingEmain.cppyament[0].status === 1;
                    const badge_url = res.data.badge_link;
                    if (hasAlreadyVerified) {

                        history.push({
                            pathname: `/conference/thank-you/${id}`,
                            state: { badge_url }
                        });
                    }
                    else {
                        history.push(`/conference/registration-update/${id}`);
                    }

                }
                if (res.data.redirect === 1) {
                    history.push('/conference/particpant-form');
                    return false;
                } else {
                    setemailexist({ ...emailexist, error_list: res.data.validate_error });
                }
            });
        });
    };

    // Reload the page after 2 seconds
    const workshopLink = () => {
        history.push('/workshop/particpant-verification');
        //http://localhost:3000/#/workshop/registration/66
    }
    const abstractLink = () => {
        history.push('/author/login');
        //http://localhost:3000/#/abstract-author/66
    }
    
    useEffect(() => {
        const img = new Image();
        img.src = abstractHomeSetup?.workshopBannerImage || "https://via.placeholder.com/800x600";
    }, [abstractHomeSetup?.workshopBannerImage]);


    return (
        <div>
            <Grid item item xs={12} sm={10} md={8} lg={6}>
                <ConferenceNavbar />
            </Grid>
            <Grid container spacing={2}>
                {/* Banner Section */}

                {/* <Box
                    sx={{
                        position: 'relative',
                        marginTop: '15px',
                        width: '100%',
                        height: isSmallScreen ? '200px' : '400px',
                        backgroundImage: `url(${(abstractHomeSetup?.conferenceBannerImage) || "https://via.placeholder.com/800x600"})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: isSmallScreen ? 'center' : 'left',
                        padding: isSmallScreen ? '10px' : '20px',
                        color: 'white',
                    }}
                >
                   
                </Box> */}
                <Box sx={{ position: 'relative', width: '100%', marginTop: '16px' }}>
                    {!loaded && (
                        <Box sx={{ width: '100%', height: isSmallScreen ? 200 : 700, background: '#ccc' }} />
                    )}
                    <img
                        src={abstractHomeSetup?.workshopBannerImage || "https://via.placeholder.com/800x600"}
                        alt="Workshop Banner"
                        style={{
                            width: '100%',
                            height: 'auto',
                            display: loaded ? 'block' : 'none',
                        }}
                        onLoad={() => setLoaded(true)}
                    />
                </Box>
                {/* <Box
                    sx={{
                        position: 'relative',
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: '16px',
                    }}
                >
                    <img
                        src={abstractHomeSetup?.conferenceBannerImage || "https://via.placeholder.com/800x600"}
                        alt="Conference Banner"
                        style={{
                            width: '100%',       // full width
                            height: 'auto',      // maintain aspect ratio
                            display: 'block',    // remove bottom gap
                        }}
                    />
                </Box> */}

                { /*marginTop="40px" */}
                <Grid container justifyContent="center" marginTop={abstractHomeSetup?.bank_status === 1 || abstractHomeSetup?.cash_status === 1 || abstractHomeSetup?.free_status === 1 || abstractHomeSetup?.online_status === 1 ? "0" : "40px"}>

                    <Grid item xs={12} sm={10} md={8} lg={6}>
                        {
                            abstractHomeSetup.c_group_registration === 1 && (
                                <Button sx={{
                                    float: 'right',
                                    marginTop: '2%',
                                    marginRight: isSmallScreen ? '100px' : '50px',
                                    ":hover": {
                                        color: "white"
                                    }
                                    , backgroundColor: abstractHomeSetup.color_code_two
                                        ? abstractHomeSetup.color_code_two
                                        : gradientBackground,
                                }}
                                    color='success'
                                    size='small'
                                    variant='contained'
                                    component={Link}  // Use the Link component here
                                    to="/conference/participants-group-registration" >
                                    Group Registration
                                </Button>
                            )


                        }

                        {(abstractHomeSetup?.bank_status === 1 ||
                            abstractHomeSetup?.cash_status === 1 ||
                            abstractHomeSetup?.free_status === 1 ||
                            abstractHomeSetup?.online_status === 1) && (
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: { xs: "column", md: "row" }, // column on mobile, row on medium+
                                        justifyContent: { xs: "center", md: "space-between" },
                                        alignItems: { xs: "center", md: "center" },
                                        mt: { xs: 2, md: 5 }, // smaller margin on mobile, larger on desktop
                                        mb: 1,
                                        gap: { xs: 1, md: 0 }, // spacing only when stacked
                                    }}
                                >
                                    <Typography
                                        variant="h4"
                                        sx={{
                                            fontWeight: "bold",
                                            color: abstractHomeSetup?.color_code_two || "#05597D",
                                            ml: { xs: 0, md: 7 }, // no margin on mobile, keep margin on large
                                            textAlign: { xs: "center", md: "left" }, // center text on mobile
                                            fontSize: { xs: "1.2rem", md: "2rem" }, // smaller on mobile
                                        }}
                                    >
                                        Conference Registration
                                    </Typography>

                                    <Button
                                        variant="contained"
                                        sx={{
                                            backgroundColor: abstractHomeSetup?.color_code_two
                                                ? abstractHomeSetup?.color_code_two
                                                : gradientBackground,
                                            color: "white",
                                            whiteSpace: "nowrap",
                                            mr: { xs: 0, md: 8 }, // keep margin only on large
                                            width: { xs: "80%", md: "auto" }, // full width on mobile, auto on large
                                            fontSize: { xs: "0.8rem", md: "1rem" }, // smaller text on mobile
                                            py: { xs: 0.6, md: 1 }, // smaller padding on mobile
                                        }}
                                        onClick={workshopLink}
                                    >
                                        For Workshop Registration Click Here
                                    </Button>
                                </Box>
                            )}

                        <Box component="form" onSubmit={handleSubmit} sx={{
                            boxShadow: 3,
                            borderRadius: 2,
                            padding: 4,
                            ml: { xs: 3, md: 5 }, // add left margin only on medium+ screens
                            width: '100%',
                            maxWidth: isSmallScreen ? '309px' : '600px', // Initial maxWidth for smaller screens
                            textAlign: 'center',
                            background: abstractHomeSetup?.color_code_four
                                ? abstractHomeSetup?.color_code_four
                                : gradientBackground,
                            color: 'white',
                            marginX: 'auto',
                            '@media (min-width: 960px)': {
                                maxWidth: '800px', // Increase maxWidth on larger screens if needed
                            },
                        }}>

                            {
                                isSmallScreen ? <br></br> : ""
                            }
                            <Typography component="h1" variant="h5">
                                Verify your Email
                            </Typography>

                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                autoComplete="off"
                                id="email"
                                label="Email Address"
                                name="email"
                                autoFocus
                                onChange={handleInput}
                                value={emailexist.email}
                                helperText={emailexist.error_list.email}
                                InputLabelProps={{ style: { color: 'white' } }}
                                FormHelperTextProps={{ style: { color: 'white' } }}
                                InputProps={{
                                    style: { color: 'white' },
                                    '&::placeholder': { color: 'white', opacity: 0.7 },
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '25px',
                                        color: 'white',
                                        '& fieldset': { borderColor: 'white' },
                                        '&:hover fieldset': { borderColor: 'white' },
                                        '&.Mui-focused fieldset': { borderColor: 'white' },
                                    },
                                    '& .MuiInputLabel-root': { color: 'white !important' },
                                    '& .MuiFormHelperText-root': { color: 'white !important' },
                                }}
                            />

                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                disabled={isButtonDisabled}
                                sx={{
                                    mt: 3,
                                    mb: 2,
                                    background: abstractHomeSetup.color_code_two || gradientBackground,
                                    borderRadius: '25px',
                                }}
                            >
                                Verify
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={12} sm={10} md={8} lg={6} marginTop="40px">
                <NewVersionAbstractFooter />
            </Grid>
        </div>
    );
};

export default ConferencePartiticpantVerirication;
